exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white; }\n  .container__form {\n    display: grid; }\n", ""]);

// exports
